// "Орлого" = Cash deposit, "Зарлага" = Cash withdrawal (CONTEXT.md).
export type CashKind = 'DEPOSIT' | 'WITHDRAWAL';

export const KIND_LABEL: Record<CashKind, string> = {
  DEPOSIT: 'Орлого',
  WITHDRAWAL: 'Зарлага',
};

export interface CashRow {
  id: number;
  transaction_date: string;
  student_name: string;
  class_name: string | null;
  kind: CashKind;
  amount: number;
  before_balance: number;
  after_balance: number;
  description: string | null;
  created_by_name: string | null;
  // Set when the row came from a Batch transaction.
  batch_id: number | null;
}

export interface CashPage {
  results: CashRow[];
  total: number;
  deposit_total: number;
  withdrawal_total: number;
}

export interface ClassOption {
  id: number;
  name: string;
}

export interface StudentOption {
  id: number;
  full_name: string;
  code: string;
  card_balance: number;
  min_balance: number;
}

export function formatMNT(n: number): string {
  return `${new Intl.NumberFormat('mn-MN').format(n)}₮`;
}

// A failed runQuery rejects with the server's `{ error }` body.
export function queryErrorMessage(e: unknown): string {
  return (e as { error?: string } | undefined)?.error ?? 'Алдаа гарлаа.';
}
